/**
 * API base path for PHP endpoints (…/server).
 * Always same-origin `/server` in the browser so this app never calls datawarehouse.
 */
export function getApiBaseUrl() {
  if (typeof window !== 'undefined') {
    return '/server';
  }

  const envUrl = (process.env.REACT_APP_API_BASE_URL || '').trim();
  if (envUrl && !/datawarehouse/i.test(envUrl)) {
    return envUrl.replace(/\/$/, '');
  }

  return '/server';
}
